/* CmdLineUserSession.js */

"use strict";
const UserSession = require("./UserSession");

class CmdLineUserSession extends UserSession {
    constructor(logger, UserEntity) {
        super(logger, UserEntity);
    }
    /*******************************************/
    /* START LISTENER REGISTRATIONS METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = CmdLineUserSession;
